package amazon.lastmile.inject

import app.nestbridge.feature.children.ui.ChildListUiFactory
import com.slack.circuit.runtime.ui.Ui
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = ChildListUiFactory::class)
public interface AppNestbridgeFeatureChildrenUiChildListUiFactory {
  @Provides
  @IntoSet
  public fun provideChildListUiFactoryFactoryMultibinding(childListUiFactory: ChildListUiFactory): Ui.Factory = childListUiFactory
}
